import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faUser } from "@fortawesome/free-solid-svg-icons";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import {
  packageGetList,
  packageAdd
} from "actions/package/actions";

import EditModal from "views/pages/package/edit-modal";
import ImageModal from "views/pages/package/image-modal";
import AssignToUser from "views/pages/package/assign-to-users";

class Pack extends React.Component {
  constructor(props) {
    super(props);

    this.modalEdit = this.modalEdit.bind(this);
    this.modalImage = this.modalImage.bind(this);
    this.handleAssignPackageModal = this.handleAssignPackageModal.bind(this);

    this.props.packageGetList();
  }

  getColumns = () => [
    {
      id: "pack-id",
      Header: "#",
      accessor: "id",
    },
    {
      Header: "Active",
      accessor: "active",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className={original.active ? "text-success" : "text-danger"}>
          {original.active ? "Active" : "Inactive"}
        </div>
      )
    },
    {
      Header: "Code",
      accessor: "code",
    },
    {
      Header: "Popular",
      accessor: "popular",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className={original.popular ? "text-success" : "text-danger"}>
          {original.popular ? "Yes" : "No"}
        </div>
      )
    },
    {
      id: "price",
      Header: "Price",
      accessor: "price",
      headerClassName: "text-center",
      className: "text-center"
    },
    {
      id: "duration",
      Header: "Duration",
      accessor: "duration",
      headerClassName: "text-center",
      className: "text-center"
    },
    {
      id: "timeUnit",
      Header: "Time Unit",
      accessor: "timeUnit",
      headerClassName: "text-center",
      className: "text-center"
    },
    {
      id: "minute",
      Header: "Minute",
      accessor: "minute",
      headerClassName: "text-center",
      className: "text-center"
    },
    {
      Header: "Limited",
      accessor: "limited",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className={original.limited ? "text-success" : "text-danger"}>
          {original.limited ? "Yes" : "No"}
        </div>
      )
    },
    {
      id: "actions",
      Header: "Actions",
      Cell: ({ original }) => (
        <div className="d-flex justify-content-around">
          {original.special && (
            <button
              className="btn btn-sm btn-warning"
              onClick={() => this.handleAssignPackageModal(original)}
            >
              <FontAwesomeIcon icon={faUser}/>
            </button>
          )}
          <button
            className="btn btn-sm btn-primary"
            onClick={() => this.modalEdit(original)}
          >
            <FontAwesomeIcon icon={faPen}/>
          </button>
          {/* <button
            className="btn btn-sm btn-warning"
            onClick={() => this.modalImage(original.id, original.name)}
          >
            <FontAwesomeIcon icon={faFileImage}/>
          </button> */}
        </div>
      ),
      headerClassName: "text-center",
      className: "text-center"
    }
  ];

  modalEdit = (pack = false) => {
    const modalObj = {
      modalSettings: {
        size: "sm"
      },
      header: pack ? `Edit Package "${pack.code}"` : "Create New Package",
      children: (
        <EditModal
          pack={pack}
          onCancel={() => this.props.closeCustomModal(modalObj)}
          onSubmit={(data) => {
            this.props.packageAdd(data);
            this.props.closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  modalImage = (packageId, packageName) => {
    const modalObj = {
      modalSettings: {
        size: "sm"
      },
      header: "Change image",
      children: (
        <ImageModal
          packageId={packageId}
          packageName={packageName}
          onCancel={() => this.props.closeCustomModal(modalObj)}
          onSubmit={() => {
            this.props.closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  handleAssignPackageModal = (pack) => {
    const modalObj = {
      modalSettings: {
        size: "sm"
      },
      header: pack.code,
      children: (
        <AssignToUser
          packageId={pack.id}
          onCancel={() => this.props.closeCustomModal(modalObj)}
          onSubmit={() => {
            this.props.closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  render() {
    const {
      packageList,
    } = this.props;

    return (
      <div className="w-100 p-2">
        <div className="d-flex justify-content-between filters">
          <h3>Package</h3>
          <div>
            <button
              className="btn btn-sm btn-success"
              onClick={() => this.modalEdit()}
            >
              Create New Package
            </button>
          </div>
        </div>

        <ReactTable
          data={packageList}
          headerClassName="table-header"
          columns={this.getColumns()}
          pageSizeOptions={[10, 20, 50, 100]}
          resizable
          className="-striped -highlight"
          loading={false}
          filterable={false}
          defaultFilterMethod={filterCaseInsensitive}
          getNoDataProps={() => ({
            style: {
              zIndex: 0
            }
          })}
          style={{
            height: "calc(100vh - 110px)"
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  packageList: state.package.packageList,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  packageGetList: bindActionCreators(packageGetList, dispatch),
  packageAdd: bindActionCreators(packageAdd, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Pack);



// WEBPACK FOOTER //
// ./src/views/pages/package/list.js